import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import hrloginimage from "../../assets/hrrlogo12.jpg";

import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

import {
  FaEye,
  FaEyeSlash,
  FaUserTie,
  FaLock,
  FaEnvelope,
  FaSignInAlt,
  FaRedo,
  FaCheckCircle,
  FaTimes,
} from "react-icons/fa";

import "../../Styles/HrLogin.css";

import Member from "../Membership/Member";
import ApiService from "../../nhrc_apis/ApiService";

const { AuthAPI, PasswordAPI } = ApiService;

function HrLogin() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const [captchaQuestion, setCaptchaQuestion] = useState("");
  const [captchaId, setCaptchaId] = useState("");
  const [captchaAnswer, setCaptchaAnswer] = useState("");

  const [captchaVerified, setCaptchaVerified] = useState(false);

  const [loadingCaptcha, setLoadingCaptcha] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showRegister, setShowRegister] = useState(false);

  /* =========================================================
     ✅ CORRECTED FORGOT PASSWORD STATES — see Login.js for the
     full explanation; same 2-step flow, no reset token.
  ========================================================= */

  const [showForgotModal, setShowForgotModal] = useState(false);
  const [forgotStep, setForgotStep] = useState(1);

  const [forgotEmail, setForgotEmail] = useState("");
  const [sendingForgotOtp, setSendingForgotOtp] = useState(false);

  const [forgotOtp, setForgotOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [resettingPassword, setResettingPassword] = useState(false);

  useEffect(() => {
    loadCaptcha();
  }, []);

  const loadCaptcha = async () => {
    try {
      setLoadingCaptcha(true);
      setCaptchaVerified(false);
      setCaptchaAnswer("");

      const res = await AuthAPI.getCaptcha();

      setCaptchaQuestion(res?.data?.question || "");
      setCaptchaId(res?.data?.captcha_id || "");
    } catch (err) {
      console.error("CAPTCHA ERROR:", err);

      toast.error("Failed to load captcha");

      setCaptchaQuestion("");
      setCaptchaId("");
    } finally {
      setLoadingCaptcha(false);
    }
  };

  const handleVerifyCaptcha = async () => {
    if (!captchaAnswer.trim()) {
      toast.error("Enter captcha answer");
      return;
    }

    if (!captchaId) {
      toast.error("Captcha is not available. Please refresh.");
      return;
    }

    try {
      await AuthAPI.verifyCaptcha({
        captcha_id: captchaId,
        answer: captchaAnswer.trim(),
      });

      setCaptchaVerified(true);

      toast.success("Captcha verified successfully");
    } catch (err) {
      console.error("CAPTCHA VERIFY ERROR:", err);

      setCaptchaVerified(false);

      toast.error(
        err?.response?.data?.detail ||
          "Captcha verification failed"
      );

      loadCaptcha();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaVerified) {
      toast.error("Please verify captcha first");
      return;
    }

    if (!username.trim() || !password.trim()) {
      toast.error("Email and Password required");
      return;
    }

    if (!captchaId || !captchaAnswer.trim()) {
      toast.error("Captcha session expired. Please verify again.");
      setCaptchaVerified(false);
      loadCaptcha();
      return;
    }

    try {
      setLoading(true);

      const payload = {
        email: username.trim().toLowerCase(),
        password: password.trim(),
        captcha_id: captchaId,
        captcha: captchaAnswer.trim(),
      };

      console.log("LOGIN PAYLOAD :", payload);

      const res = await AuthAPI.login(payload);

      console.log("LOGIN RESPONSE :", res?.data);

      const token =
        res?.data?.token ||
        res?.data?.access_token;

      if (!token) {
        toast.error("Token not received");
        return;
      }

      const member =
        res?.data?.member ||
        res?.data?.user;

      if (!member) {
        toast.error("User data not found");
        return;
      }

      console.log("LOGIN MEMBER :", member);

      localStorage.removeItem("token");
      localStorage.removeItem("adminToken");
      localStorage.removeItem("hrToken");
      localStorage.removeItem("studentToken");

      localStorage.removeItem("hrLoggedInUser");
      localStorage.removeItem("hrMember");

      localStorage.setItem("token", token);

      const status =
        member?.status?.toLowerCase();

      if (status === "pending") {
        toast.error(
          "Your account is pending approval"
        );

        return;
      }

      if (status === "rejected") {
        toast.error(
          "Your account was rejected by admin"
        );

        return;
      }

      const role =
        member?.role?.toUpperCase();

      console.log("USER ROLE :", role);

      if (role === "ADMIN") {
        localStorage.setItem(
          "adminToken",
          token
        );
      } else if (
        role === "HR" ||
        role === "EMPLOYEE"
      ) {
        localStorage.setItem(
          "hrToken",
          token
        );
      } else {
        localStorage.setItem(
          "studentToken",
          token
        );
      }

      localStorage.setItem(
        "hrLoggedInUser",
        JSON.stringify(member)
      );

      localStorage.setItem(
        "hrMember",
        JSON.stringify(member)
      );

      toast.success("Login successful");

      setTimeout(() => {
        navigate("/hrdashboard");
      }, 800);

    } catch (err) {
      console.error("LOGIN ERROR :", err);

      if (err?.response?.status === 422) {
        const detail = err?.response?.data?.detail;

        const detailMsg = Array.isArray(detail)
          ? (detail[0]?.msg || "Validation Error")
          : (detail || "Validation Error");

        toast.error(detailMsg);
      } else {
        toast.error(
          err?.response?.data?.detail ||
            err?.response?.data?.message ||
            "Login failed"
        );
      }

      loadCaptcha();
      setCaptchaVerified(false);

    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     ✅ FORGOT PASSWORD HANDLERS
  ========================================================= */

  const openForgotModal = () => {
    setShowForgotModal(true);
    setForgotStep(1);
    setForgotEmail(username.trim());
    setForgotOtp("");
    setNewPassword("");
    setConfirmNewPassword("");
  };

  const closeForgotModal = () => {
    setShowForgotModal(false);
  };

  /* STEP 1 — POST /password/forgot-password?email=... */
  const handleSendForgotOtp = async () => {
    if (!forgotEmail.trim()) {
      toast.error("Please enter your email address.");
      return;
    }

    try {
      setSendingForgotOtp(true);

      await PasswordAPI.forgotPassword(
        forgotEmail.trim().toLowerCase()
      );

      toast.success("OTP sent to your email");

      setForgotStep(2);
    } catch (err) {
      console.error("FORGOT PASSWORD ERROR:", err);

      toast.error(
        err?.response?.data?.detail ||
          "Failed to send OTP. Please check the email and try again."
      );
    } finally {
      setSendingForgotOtp(false);
    }
  };

  /* STEP 2 — POST /password/reset-password
     { email, otp, new_password, confirm_password } */
  const handleResetPassword = async () => {
    if (!forgotOtp.trim()) {
      toast.error("Please enter the OTP.");
      return;
    }

    if (!newPassword.trim() || !confirmNewPassword.trim()) {
      toast.error("Please fill both password fields.");
      return;
    }

    if (newPassword.length < 6) {
      toast.error("Password must be at least 6 characters.");
      return;
    }

    if (newPassword !== confirmNewPassword) {
      toast.error("Passwords do not match.");
      return;
    }

    try {
      setResettingPassword(true);

      await PasswordAPI.resetPassword({
        email: forgotEmail.trim().toLowerCase(),
        otp: forgotOtp.trim(),
        new_password: newPassword.trim(),
        confirm_password: confirmNewPassword.trim(),
      });

      toast.success("Password reset successfully! Please log in.");

      closeForgotModal();
    } catch (err) {
      console.error("RESET PASSWORD ERROR:", err);

      toast.error(
        err?.response?.data?.detail || "Failed to reset password"
      );
    } finally {
      setResettingPassword(false);
    }
  };

  return (
    <>
      <div className="hrlogin-wrapper">

        <div className="hrlogin-card">

          <div className="hrlogin-left">

            <img
              src={hrloginimage}
              className="hrlogin-image"
              alt="NHRC HR Login"
            />

          </div>

          <div className="hrlogin-right">

            <div className="hrlogin-body">

              <div className="hrlogin-icon-wrapper">

                <FaUserTie className="hrlogin-icon" />

              </div>

              <h2 className="hrlogin-title">
                HR Login
              </h2>

              <p className="hrlogin-subtitle">
                Welcome back! Please sign in to continue.
              </p>

              <div className="hrlogin-title-line"></div>

              <form onSubmit={handleSubmit}>

                <div className="hrlogin-field">

                  <label className="hrlogin-label">
                    Email Address
                  </label>

                  <div className="hrlogin-input-wrapper">

                    <FaEnvelope className="hrlogin-input-icon" />

                    <input
                      type="email"
                      className="hrlogin-input"
                      value={username}
                      onChange={(e) =>
                        setUsername(e.target.value)
                      }
                      placeholder="Enter your email"
                      autoComplete="email"
                      required
                    />

                  </div>

                </div>

                <div className="hrlogin-field">

                  <label className="hrlogin-label">
                    Password
                  </label>

                  <div className="hrlogin-input-wrapper">

                    <FaLock className="hrlogin-input-icon" />

                    <input
                      type={
                        showPassword
                          ? "text"
                          : "password"
                      }
                      className="hrlogin-input hrlogin-password-input"
                      value={password}
                      onChange={(e) =>
                        setPassword(e.target.value)
                      }
                      placeholder="Enter your password"
                      autoComplete="current-password"
                      required
                    />

                    <button
                      type="button"
                      className="hrlogin-password-toggle"
                      onClick={() =>
                        setShowPassword(!showPassword)
                      }
                      aria-label={
                        showPassword
                          ? "Hide password"
                          : "Show password"
                      }
                    >
                      {showPassword ? (
                        <FaEyeSlash />
                      ) : (
                        <FaEye />
                      )}
                    </button>

                  </div>

                </div>

                <div className="hrlogin-forgot-row">

                  <button
                    type="button"
                    className="hrlogin-forgot"
                    onClick={openForgotModal}
                  >
                    Forgot Password?
                  </button>

                </div>

                <div className="hrlogin-captcha-section">

                  <div className="hrlogin-captcha-header">
                    <span>
                      Solve the captcha to continue
                    </span>
                  </div>

                  <div className="hrlogin-captcha-row">

                    <div className="hrlogin-captcha-question">

                      {loadingCaptcha ? (
                        <span className="captcha-loading">
                          Loading...
                        </span>
                      ) : (
                        <span>
                          {captchaQuestion || "Captcha"}
                        </span>
                      )}

                    </div>

                    <input
                      type="text"
                      className="hrlogin-captcha-input"
                      placeholder="Enter Answer"
                      value={captchaAnswer}
                      onChange={(e) => {
                        setCaptchaAnswer(
                          e.target.value
                        );

                        setCaptchaVerified(false);
                      }}
                      disabled={loadingCaptcha}
                    />

                    <button
                      type="button"
                      className={
                        captchaVerified
                          ? "hrlogin-verify-btn verified"
                          : "hrlogin-verify-btn"
                      }
                      onClick={handleVerifyCaptcha}
                      disabled={
                        loadingCaptcha ||
                        captchaVerified
                      }
                    >
                      {captchaVerified ? (
                        <>
                          <FaCheckCircle />
                          Verified
                        </>
                      ) : (
                        "Verify"
                      )}
                    </button>

                  </div>

                  {captchaVerified && (
                    <div className="hrlogin-captcha-success">

                      <FaCheckCircle />

                      <span>
                        Captcha verified successfully!
                      </span>

                    </div>
                  )}

                  {!captchaVerified && (
                    <button
                      type="button"
                      className="hrlogin-refresh-captcha"
                      onClick={loadCaptcha}
                      disabled={loadingCaptcha}
                    >
                      <FaRedo />
                      Refresh captcha
                    </button>
                  )}

                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="hrlogin-btn1"
                >

                  <FaSignInAlt />

                  <span>
                    {loading
                      ? "Signing In..."
                      : "Login"}
                  </span>

                </button>

              </form>

              <p className="hrlogin-copyright">
                © 2025 National Human Resource Club.
                All Rights Reserved.
              </p>

            </div>

          </div>

        </div>

      </div>

      <Modal
        show={showRegister}
        onHide={() => setShowRegister(false)}
        centered
        size="lg"
        backdrop="static"
        className="membership-modal"
      >

        <Modal.Header
          closeButton
          className="border-0"
        >

          <Modal.Title className="fw-bold">
            Membership Form
          </Modal.Title>

        </Modal.Header>

        <Modal.Body>
          <Member />
        </Modal.Body>

      </Modal>

      {/* =========================================================
          ✅ CORRECTED FORGOT PASSWORD MODAL — 2 steps now.
      ========================================================= */}

      {showForgotModal && (
        <div
          className="hrforgot-modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="hrforgot-modal-card"
            style={{
              background: "#fff",
              borderRadius: "12px",
              padding: "28px",
              width: "100%",
              maxWidth: "400px",
              position: "relative",
            }}
          >
            <button
              type="button"
              className="hrforgot-modal-close"
              onClick={closeForgotModal}
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                background: "none",
                border: "none",
                fontSize: "18px",
                cursor: "pointer",
              }}
              aria-label="Close"
            >
              <FaTimes />
            </button>

            <h4 style={{ marginBottom: "8px" }}>Reset Password</h4>

            {forgotStep === 1 && (
              <>
                <p style={{ fontSize: "14px", color: "#666", marginBottom: "16px" }}>
                  Enter your email address and we'll send you an OTP.
                </p>

                <div className="hrlogin-input-wrapper" style={{ marginBottom: "16px" }}>
                  <FaEnvelope className="hrlogin-input-icon" />
                  <input
                    type="email"
                    className="hrlogin-input"
                    placeholder="Enter your email"
                    value={forgotEmail}
                    onChange={(e) => setForgotEmail(e.target.value)}
                  />
                </div>

                <button
                  type="button"
                  className="hrlogin-btn1"
                  style={{ width: "100%" }}
                  disabled={sendingForgotOtp}
                  onClick={handleSendForgotOtp}
                >
                  {sendingForgotOtp ? "Sending OTP..." : "Send OTP"}
                </button>
              </>
            )}

            {forgotStep === 2 && (
              <>
                <p style={{ fontSize: "14px", color: "#666", marginBottom: "16px" }}>
                  Enter the OTP sent to <b>{forgotEmail}</b> and your new password.
                </p>

                <input
                  type="text"
                  className="hrlogin-input"
                  placeholder="Enter OTP"
                  value={forgotOtp}
                  onChange={(e) => setForgotOtp(e.target.value)}
                  style={{ marginBottom: "12px", width: "100%" }}
                />

                <div className="hrlogin-input-wrapper" style={{ marginBottom: "12px" }}>
                  <FaLock className="hrlogin-input-icon" />
                  <input
                    type={showNewPassword ? "text" : "password"}
                    className="hrlogin-input hrlogin-password-input"
                    placeholder="New password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="hrlogin-password-toggle"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  >
                    {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>

                <div className="hrlogin-input-wrapper" style={{ marginBottom: "16px" }}>
                  <FaLock className="hrlogin-input-icon" />
                  <input
                    type={showNewPassword ? "text" : "password"}
                    className="hrlogin-input"
                    placeholder="Confirm new password"
                    value={confirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                  />
                </div>

                <button
                  type="button"
                  className="hrlogin-btn1"
                  style={{ width: "100%", marginBottom: "8px" }}
                  disabled={resettingPassword}
                  onClick={handleResetPassword}
                >
                  {resettingPassword ? "Resetting..." : "Reset Password"}
                </button>

                <button
                  type="button"
                  className="hrlogin-refresh-captcha"
                  style={{ width: "100%" }}
                  disabled={sendingForgotOtp}
                  onClick={handleSendForgotOtp}
                >
                  <FaRedo />
                  Resend OTP
                </button>
              </>
            )}

          </div>
        </div>
      )}
    </>
  );
}

export default HrLogin;